import React, { useReducer } from "react";
import axios from "axios";
import ProductContext from "./ProductContext";
import ProductReducer from "./ProductReducer";
import { GET_MERN_PRODUCTS, MERN_LOADING, MERN_PRODUCTS_ERROR } from "../types";

const ProductState = (props) => {
  const initialState = {
    mern_products: null,
    mern_loading: false,
    mern_error: null,
  };

  const [state, dispatch] = useReducer(ProductReducer, initialState);

  const getMernProducts = async (data) => {
    try {
      dispatch({
        type: MERN_LOADING,
      });

      const res = await axios.get(`/api/mern_products/${data}`);

      dispatch({
        type: GET_MERN_PRODUCTS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: MERN_PRODUCTS_ERROR,
        payload: err.response.msg,
      });
    }
  };

  return (
    <ProductContext.Provider
      value={{
        mern_products: state.mern_products,
        mern_loading: state.mern_loading,
        mern_error: state.mern_error,
        getMernProducts,
      }}
    >
      {props.children}{" "}
    </ProductContext.Provider>
  );
};

export default ProductState;
